module.exports = __webpack_public_path__ + "img/S1.5b77b7c0.a3a597f5.png";